<template>
  <div class="container">
    <div class="row">
      <div class="col-md-8 m-auto">
        <div id="empty-group">
          <div class="title">
            <p class="typo-heading24 typo-semibold text-center" v-if="page == 'search' && value && title">
              {{ title }}
              <span class="text-primary">"{{ value }}"</span>
            </p>
          </div>
          <div class="content">
            <div class="d-flex justify-content-center mb-3">
              <img :src="require('@/core/assets/EmptyPages/page.png')">
            </div>
            <template v-if="!customTitle">
              <h1 class="typo-heading24 typo-semibold text-light-high mb-1 text-center">{{ title2 }}</h1>
            </template>
            <slot name="title" v-else></slot>
            <p class="typo-paragraph14 typo-regular text-dark6 text-center" v-if="!customContent">{{ content }}</p>
            <p class="typo-paragraph14 typo-regular text-dark6 text-center" v-else>
              <slot name="content"></slot>
            </p>

            <div class="btn-create-group text-center" v-if="page && page != 'search'">
              <slot name="button" :btnText="btnText"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GpEmptyPage",
  props: {
    page: String,
    value: String,
    pageType: String,
    action: {
      type: Function,
      default: () => {
        return () => {};
      }
    },
    tabText: String,
    customContent: {
      type: Boolean,
      default: false
    },
    customTitle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    image() {
      return this.page && this.config.pages[this.page].hasOwnProperty("image") ? this.config.pages[this.page].image : this.defaultImage;
    },
    content() {
      return this.page && this.config.pages[this.page].hasOwnProperty("content") ? this.config.pages[this.page].content : "";
    },
    btnText() {
      return this.page && this.config.pages[this.page].hasOwnProperty("btnText") ? this.config.pages[this.page].btnText : "";
    },
    title() {
      return this.page && this.config.pages[this.page].hasOwnProperty("title") ? this.config.pages[this.page].title : "";
    },
    title2() {
      return this.page && this.config.pages[this.page].hasOwnProperty("title") ? this.config.pages[this.page].title : "";
    },
    config() {
      return {
        pages: {
          shop: {
            image: require("@/core/assets/EmptyPages/homepages.svg"),
            content: this.$t("empty.shop.content", { type: this.tabText }),
            btnText: this.$t("empty.shop.btnText")
          },
          collectionpages: {
            image: require("@/core/assets/EmptyPages/collectionpages.svg"),
            content: this.$t("empty.collectionpages.content"),
            btnText: this.$t("empty.collectionpages.btnText")
          },
          articlepages: {
            image: require("@/core/assets/EmptyPages/articlepages.svg"),
            content: this.$t("empty.articlepages.content"),
            btnText: this.$t("empty.articlepages.btnText"),
            title: this.$t("empty.articlepages.title")
          },
          homepages: {
            image: require("@/core/assets/EmptyPages/homepages.svg"),
            content: this.$t("empty.homepages.content"),
            btnText: this.$t("empty.homepages.btnText")
          },
          subpages: {
            image: require("@/core/assets/EmptyPages/subpages.svg"),
            content: this.$t("empty.subpages.content"),
            btnText: this.$t("empty.landingpages.btnText"),
            title: this.$t("empty.landingpages.title")
          },
          productpages: {
            image: require("@/core/assets/EmptyPages/productpages.svg"),
            content: this.$t("empty.productpages.content"),
            btnText: this.$t("empty.productpages.btnText")
          },
          group: {
            image: require("@/core/assets/EmptyPages/group.svg"),
            content: this.$t("empty.group.content"),
            btnText: this.$t("empty.group.btnText"),
            title: this.$t("empty.group.title")
          },
          addPages: {
            content: this.$t("empty.addPages.content"),
            title: this.$t("empty.addPages.title")
          },
          search: {
            // title: this.$t("empty.search.title"),
            image: require("@/core/assets/EmptyPages/search.svg"),
            content: this.$t("empty.search.content")
          },
          videoTutorial: {
            image: require("@/core/assets/EmptyPages/video-tutorial.svg"),
            content: this.$t("empty.videoTutorial.content"),
            btnText: this.$t("empty.videoTutorial.btnText")
          },
          integrations: {
            image: require("@/core/assets/EmptyPages/video-tutorial.svg"),
            content: this.$t("empty.integrations.content"),
            btnText: this.$t("empty.integrations.btnText")
          }
        },
        defaultImage: ""
      };
    }
  }
};
</script>

<style lang="scss" scoped>
#empty-group {
  margin-top: 74px;


  .btn-create-group {
    margin-top: 24px;
  }
  .step {
    .step-content {
      p {
        min-width: 250px;
        max-width: 250px;
      }
    }
  }
}
</style>
